import { defineSubappRoutes } from 'util/subapp'
import { CHAT_PAGE } from '../pages'
import chatPageHandler from './chatPageHandler'

// routes get injected into router
export const routeDefinitions = []

routeDefinitions.push({
  page: CHAT_PAGE,
  route: {
    path: '/chats',
  },
  handler: chatPageHandler,
})

export const {
  routes,
  pages,
  handlers,
  registerPageReducer,
} = defineSubappRoutes(routeDefinitions)
